// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"9ab4a311","336":"ab61c188","340":"0e546c89","346":"25ac3add","542":"fb7b637c","896":"943411b1","973":"831b15ba"}[chunkId] + ".chunk.css";
};